import { useDispatch } from "@wordpress/data";
import { __ } from "@wordpress/i18n";
import type React from "react";
import { useState } from "react";
import Button from "../../button";
import { authStore } from "../auth-store";

type Props = { title: string; message: string };

export const SuccessStage: React.FC<Props> = ({ title, message }) => {
	const { closeModal } = useDispatch(authStore);
	const [isClosing, setIsClosing] = useState(false);

	const onClose = () => {
		if (isClosing) return;
		setIsClosing(true);
		closeModal();
		window.location.reload();
	};

	return (
		<div className="leat-auth-modal__success">
			<div className="leat-auth-modal__success-icon" aria-hidden="true">
				✓
			</div>
			<p className="leat-auth-modal__success-title">{title}</p>
			<p className="leat-auth-modal__success-message">{message}</p>
			<Button
				type="button"
				variant="contained"
				className="leat-auth-modal__submit leat-button--pill"
				onClick={onClose}
				disabled={isClosing}
			>
				{isClosing ? __("Closing…", "leat-crm") : __("Close", "leat-crm")}
			</Button>
		</div>
	);
};
